var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"zgDeptDialog",attrs:{"title":"选择部门机构","size":"mini_mini","footerButton":_vm.btns,"close-on-click-modal":false}},[_c('mw-tree',{ref:"deptTree",staticClass:"mw-dialog-body",attrs:{"url":_vm.deptTreeUrl,"multipleLeaf":true,"checkNodes":_vm.checkNodes,"async":true,"expandedFirst":true,"multiple":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2892a010","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/views/systemSet/org/user/zgDept.vue
// module id = 1191
// module chunks = 0 1